<script>
  let showLeftDropdown = false;
  let showRightDropdown = false;

  function toggleLeftDropdown() {
    showLeftDropdown = !showLeftDropdown;
  }

  function toggleRightDropdown() {
    showRightDropdown = !showRightDropdown;
    if (showRightDropdown) {
      const dropdown = document.querySelector('.right-product-thumbnail .dropdown-content');
      if (dropdown) {
        let dropdownRect = dropdown.getBoundingClientRect();
        if (dropdownRect.top < 0) {
          // If the dropdown goes off-screen at the top, adjust its position
          dropdown.style.top = '0';
          dropdown.style.transform = 'translateY(100%)';
        }
      }
    }
  }

  function toggleDarkMode() {
    document.body.classList.toggle('dark-mode');
  }
</script>

<div class="header-container">
    <!-- Left Product Thumbnail -->
    <div class="left-product-thumbnail">
        <a href="Fetal" class="toggle-btn" on:click|preventDefault={toggleLeftDropdown}>
            <img src="images/thumb/sponsor_thumb.webp" alt="left sponsor">
        </a>
        {#if showLeftDropdown}
            <div class="dropdown-content">
            <a href="Fetal">
                <img src="images/thumb/fetal6label_thumb.webp" alt="left sponsor">
            </a>
            <br>
            <a href="Bat">
                <img src="images/thumb/bat_gum_thumb.webp" alt="left sponsor">
            </a>
            </div>
        {/if}
    </div>
    <h1 style="text-align:center">0x888{name}</h1>
    <!-- Right Product Thumbnail -->
    <div class="right-product-thumbnail">
        <a href="Bat" class="toggle-btn" on:click|preventDefault={toggleRightDropdown}>
            <img src="images/thumb/product_thumb.webp" alt="Right Product">
        </a>
        {#if showRightDropdown}
            <div class="dropdown-content">
            <a href="Bat">
                <img src="images/thumb/bat_gum_thumb.webp" alt="Right Product">
            </a>
            <br>
            <a href="Fetal">
                <img src="images/thumb/fetal6label_thumb.webp" alt="Right Product">
            </a>
            <br>
            <a href="Stickers">
                <img src="images/thumb/box_sticker_thumb.webp" alt="Right Product">
            </a>
            </div>
        {/if}
    </div>
</div>
<style>
.header-container {
    /* existing styles */
    display: flex; /* Use flexbox for layout */
    justify-content: space-between; /* Space out header and products */
    align-items: center; /* Vertically center items */
}
.left-product-thumbnail,
.right-product-thumbnail {
    /* Set the max-height smaller than before if they are still too big */
    max-height: 35px; /* Adjust this value to the desired size */
    /* Set a max-width if you also want to control the width */
    max-width: 60px; /* Adjust this value based on your layout needs */
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative; /* Add this to ensure dropdown is positioned relative to these containers */
    margin-right: 16px; 
}
/* Additional styles for the thumbnails to ensure they're clickable */
.left-product-thumbnail a,
.right-product-thumbnail a {
    display: inline-block;
    height: 100%;
}
/* Style for the thumbnail images */
.left-product-thumbnail img,
.right-product-thumbnail img {
    max-height: 100%;
    max-width: 100%; /* Ensures the image does not exceed the bounds of its container */
    height: auto; /* Maintain aspect ratio */
    width: auto; /* Maintain aspect ratio */
}
.left-product-thumbnail .dropdown-content {
    left: 100%; /* This positions the dropdown to the right of the thumbnail */
    top: 0; /* Aligns the dropdown with the top of the thumbnail */
}
.right-product-thumbnail .dropdown-content {
    right: 100%; /* This positions the dropdown to the left of the thumbnail */
    top: 0; /* Aligns the dropdown with the top of the thumbnail */
}
.left-product-thumbnail .dropdown-content {
    display: none;
    position: absolute;
    left: 100%; /* Make the dropdown appear to the right of the thumbnail */
    top: 50%;  /* Center it vertically */
    transform: translateY(-50%); /* Adjust this if the dropdown is not vertically centered */
    top: 100%; /* Align the top of the dropdown with the bottom of the thumbnail */
    transform: translateY(0); /* Reset transform */
}
.right-product-thumbnail .dropdown-content {
    display: none;
    position: absolute;
    right: 100%; /* Make the dropdown appear to the left of the thumbnail */
    top: 50%; /* Center it vertically */
    transform: translateY(-50%); /* Adjust this if the dropdown is not vertically centered */
    top: 100%; /* Align the top of the dropdown with the bottom of the thumbnail */
    transform: translateY(0); /* Reset transform */
}
/* Light mode styles for dropdown content */
.dropdown-content {
    display: none;
    position: absolute;
    background-color: #f9f9f9; /* Light background for light mode */
    color: black; /* Dark text for visibility in light mode */
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1;
    border: 1px solid #ccc; /* Border color for light mode */
}
.dropdown-content a {
    color: black; /* Dark text for visibility in light mode */
    padding: 12px 16px;
    text-decoration: none;
    display: block;
}
.dropdown-content a:hover {
    background-color: #e8e8e8; /* Slightly darker background on hover for contrast in light mode */
}
/* Dark mode styles for dropdown content */
.dark-mode .dropdown-content {
    background-color: #333; /* Dark background for dark mode */
    color: white; /* Light text for visibility in dark mode */
    border: 1px solid #444; /* Border color for dark mode */
}
.dark-mode .dropdown-content a {
    color: white; /* Light text for visibility in dark mode */
}
.dark-mode .dropdown-content a:hover {
    background-color: #555; /* Slightly lighter background on hover for contrast in dark mode */
}
/* Style for images inside dropdown content */
.dropdown-content img {
    max-height: 60px; /* Set maximum height to 60 pixels */
    max-width: 60px;  /* Set maximum width to 60 pixels */
    height: auto;     /* Maintain aspect ratio */
    width: auto;      /* Maintain aspect ratio */
}
/* Light mode styles for dropdown content */
.dropdown-content {
    display: none;
    position: absolute;
    background-color: #f9f9f9; /* Light background for light mode */
    color: black; /* Dark text for visibility in light mode */
    /* ...other styles... */
    /* Ensure that there's no background-color set for .dropdown-content elsewhere
    that could override this */
}
/* ... */
/* Dark mode styles for dropdown content */
body.dark-mode .dropdown-content {
    background-color: #333; /* Dark background for dark mode */
    color: white; /* Light text for visibility in dark mode */
    border: 1px solid #444; /* Border color for dark mode */
    /* ...other styles... */
    /* Ensure that there's no background-color set for .dropdown-content elsewhere
    that could override this */
}
/* Add a :global modifier to the selector to ensure it affects the global body element */
:global(body.dark-mode) .dropdown-content {
  background-color: #333; /* Dark background for dark mode */
  color: white; /* Light text for visibility in dark mode */
  /* ...other styles... */
}
</style>
